import { ROOT_NODE } from "@craftjs/core/dist/cjs";

function selectAllChildrens(actions, query, id) {
  // If query and actions are not available, return
  if (!query || !actions) {
    return;
  }

  // Get the currently selected node
  id = id ?? ROOT_NODE;

  if (!id) return; // If no node is selected, return

  // Get the childrens of the currently selected node
  const childrens = query.node(id).descendants();

  if (!childrens || childrens.length === 0) {
    return;
  }

  actions.selectNode(childrens);
}

export default selectAllChildrens;
